import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "swipe-container",
  ref: "swipeContainer"
}
const _hoisted_2 = { class: "fullscreen-content" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "fullscreen-caption" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "fullscreen-content" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "fullscreen-caption" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "fullscreen-content" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "fullscreen-caption" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.image)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fullscreen-overlay",
        onTouchstart: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleTouchStart && _ctx.handleTouchStart(...args))),
        onTouchmove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleTouchMove && _ctx.handleTouchMove(...args))),
        onTouchend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleTouchEnd && _ctx.handleTouchEnd(...args))),
        onMousedown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args))),
        onMousemove: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args))),
        onMouseup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleMouseUp && _ctx.handleMouseUp(...args))),
        onMouseleave: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleMouseUp && _ctx.handleMouseUp(...args)))
      }, [
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
        }, "←"),
        _createElementVNode("div", _hoisted_1, [
          (_ctx.previousImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "swipe-layer top-layer",
                style: _normalizeStyle(_ctx.topLayerStyle)
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: _ctx.previousImage.imgurl,
                    alt: _ctx.previousImage.title,
                    class: "fullscreen-image"
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.previousImage.title), 1),
                    _createElementVNode("a", {
                      href: _ctx.previousImage.click ? `/v1/api/click?${_ctx.previousImage.click}` : _ctx.previousImage.url,
                      target: "_blank",
                      class: "source-link",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    }, " Visit Source ", 8, _hoisted_5)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "swipe-layer visible-layer",
            style: _normalizeStyle(_ctx.visibleLayerStyle)
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.image.imgurl,
                alt: _ctx.image.title,
                class: "fullscreen-image"
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.image.title), 1),
                _createElementVNode("a", {
                  href: _ctx.image.click ? `/v1/api/click?${_ctx.image.click}` : _ctx.image.url,
                  target: "_blank",
                  class: "source-link",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, " Visit Source ", 8, _hoisted_9)
              ])
            ])
          ], 4),
          (_ctx.nextImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "swipe-layer bottom-layer",
                style: _normalizeStyle(_ctx.bottomLayerStyle)
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: _ctx.nextImage.imgurl,
                    alt: _ctx.nextImage.title,
                    class: "fullscreen-image"
                  }, null, 8, _hoisted_11),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.nextImage.title), 1),
                    _createElementVNode("a", {
                      href: _ctx.nextImage.click ? `/v1/api/click?${_ctx.nextImage.click}` : _ctx.nextImage.url,
                      target: "_blank",
                      class: "source-link",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, " Visit Source ", 8, _hoisted_13)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true)
        ], 512)
      ], 32))
    : _createCommentVNode("", true)
}